import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { ResortsSearch } from '../pages'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  numberOfTrips,
  activePage,
  searchFilters,
  inputFocus,
} from '../actions/search-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
} from '../actions/main-actions'

import { selectedPin, opennedMarker } from '../actions/dive-guide-actions'
import { currencyDirective } from '../directives'
import 'babel-polyfill'
import 'whatwg-fetch'
import { getLanguage, getTranslations } from 'utils'

import ErrorHandler from '../components/ErrorHandler'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    numberOfTrips,
    selectedCurrency,
    itineraryPopupOpen,
    itineraryPopupData,
    activePage,
    searchFilters,
    inputFocus,
    selectedPin,
    opennedMarker,
  }),
)

let language = getLanguage()
let messages = {}

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('search-dr', ResortsSearch, {
    ...window.locationInfo,
    isWidget: window.isWidget,
    liveaboardDetails: window.liveaboardDetails,
    filters: window.filters,
    locationCoordinates: window.locationCoordinates,
    trustpilotLocale: window.trustpilotLocale,
    countryCode: window.countryCode,
  })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
